import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=053a4a5e&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=053a4a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053a4a5e",
  null
  
)

export default component.exports